import React from 'react';

import Button from '@atlaskit/button';

const ButtonSubtleLinkExample = (): React.JSX.Element => {
	return <Button appearance="subtle-link">Subtle link button</Button>;
};

export default ButtonSubtleLinkExample;
